import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { routerConfig } from "./routes";
import { useEffectiveDocumentDir } from "@/hooks/useEffectiveDocumentDir";
import { Toaster } from "sonner";
import Done from "@/assets/features/candidates/Done";
import Feedback from "@/assets/comman/Feedback";
import Error from "./assets/comman/Error";
import { AlertCircleIcon } from "lucide-react";

const viteBaseUrl = import.meta.env.BASE_URL ?? "/";
const routerBasename =
  viteBaseUrl === "/" ? "/" : viteBaseUrl.replace(/\/$/, "");

const router = createBrowserRouter(routerConfig, { basename: routerBasename });
const queryClient = new QueryClient();

function App() {
  const shellDir = useEffectiveDocumentDir();
  const isRTL = shellDir === "rtl";



  return (
    <QueryClientProvider client={queryClient}>

      <Toaster
        position={isRTL ? "top-left" : "top-right"}
        icons={{
          success: <Done />,
          error: <Error />,
          info: <AlertCircleIcon color="#0552D6" />,
          loading: <Feedback />,
        }}
        closeButton
        duration={4000}
      />
      <div
        dir={isRTL ? "rtl" : "ltr"}
        className={isRTL ? "rtl" : "ltr"}
        style={{ direction: isRTL ? "rtl" : "ltr" }}
      >
        <RouterProvider router={router} />
      </div>
      
  
    </QueryClientProvider>
  );
}

export default App;
